import { api } from "@/lib/api";

const CHUNK_SIZE = 5 * 1024 * 1024; // 5 MB — stays under proxy body limits

// THE SHARED 15s TIMEOUT DOES NOT FIT AN UPLOAD, AND SILENTLY BROKE THIS.
//
// api's default timeout is tuned for small JSON calls that answer in well
// under a second. Applied to a 5 MB body it becomes a minimum bandwidth
// requirement: finishing one chunk inside 15s needs ~2.7 Mbps of sustained
// UPLOAD, which plenty of office and site connections do not have. Above that
// it works; below it, every attempt aborts at exactly 15s.
//
// It fails the worst possible way, too. A timeout produces no response, so
// there is no status and no message from the server -- the form fell back to
// "Could not create the meeting", which reads as the button doing nothing.
// And POSTs are deliberately not retried (see api.js: re-sending a mutation in
// a payroll system can double-apply it), so there is no second chance either.
//
// 3 minutes per chunk tolerates roughly 0.22 Mbps. That is slow enough to
// cover a bad site connection and still bounded, so a genuinely dead request
// gives up rather than hanging forever.
const CHUNK_TIMEOUT_MS = 180000;

// Uploads a video to the backend in ordered chunks. Returns an upload_id
// that the create-meeting call references to assemble + store the file.
//
// onProgress reports AFTER each chunk lands. On a slow link the first callback
// can be minutes away, so callers should show something moving before it
// arrives -- otherwise a working upload is indistinguishable from a hung one.
export async function uploadVideoChunked(file, onProgress) {
    const uploadId = `up${Date.now()}${Math.random().toString(36).slice(2, 8)}`;
    const total = Math.ceil(file.size / CHUNK_SIZE);
    for (let i = 0; i < total; i++) {
        const blob = file.slice(i * CHUNK_SIZE, (i + 1) * CHUNK_SIZE);
        const fd = new FormData();
        fd.append("upload_id", uploadId);
        fd.append("chunk_index", i);
        fd.append("total_chunks", total);
        fd.append("file", blob, file.name);
        await api.post("/safety/upload/chunk", fd, {
            headers: { "Content-Type": "multipart/form-data" },
            timeout: CHUNK_TIMEOUT_MS,
        });
        if (onProgress) onProgress(Math.round(((i + 1) / total) * 100));
    }
    return uploadId;
}
